import { listNaviProfitStreams, NAVI_PROFIT_DEFAULTS } from "../../lib/naviProfitModel";
import { formatMoney } from "../../lib/meetupPricing";

export default function NaviProfitStreamsCard() {
  const streams = listNaviProfitStreams();
  const subs = NAVI_PROFIT_DEFAULTS.subscriptions;
  const ads = NAVI_PROFIT_DEFAULTS.adRatesDailyUsd;

  return (
    <section className="rounded-[2rem] border border-cyan-100 bg-gradient-to-br from-slate-950 to-slate-900 text-white shadow-xl p-6">
      <p className="text-sm uppercase tracking-[0.18em] text-cyan-400 font-semibold mb-1">
        Mansion economics
      </p>
      <h3 className="text-2xl font-serif font-bold mb-2">How CaribNavi stays profitable — transparently</h3>
      <p className="text-sm text-slate-300 mb-5">
        Partners keep their quoted payout. Mansion earns from platform services, subscriptions, and
        discovery ads — not from VAT.
      </p>

      <div className="grid sm:grid-cols-2 gap-3 mb-5">
        {streams.map((stream) => (
          <div key={stream.id} className="rounded-xl bg-white/5 border border-white/10 p-3">
            <p className="font-semibold text-cyan-200 text-sm">{stream.title}</p>
            <p className="text-xs text-slate-400 mt-1">{stream.description}</p>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4 text-sm">
        <div className="rounded-xl bg-white/5 p-4">
          <p className="font-semibold text-white mb-2">Recurring subscriptions</p>
          <ul className="space-y-1 text-slate-300 text-xs">
            <li>Explorer PRO — {formatMoney(subs.explorerProMonthlyUsd)}/mo</li>
            <li>Explorer PRO Yearly — {formatMoney(subs.explorerProYearlyUsd)}</li>
            <li>Business Featured — {formatMoney(subs.businessFeaturedMonthlyUsd)}/mo</li>
            <li>Business PRO — {formatMoney(subs.businessProMonthlyUsd)}/mo</li>
          </ul>
        </div>
        <div className="rounded-xl bg-white/5 p-4">
          <p className="font-semibold text-white mb-2">Ad placement (per day)</p>
          <ul className="space-y-1 text-slate-300 text-xs">
            <li>Sponsored — {formatMoney(ads.sponsored)}</li>
            <li>Featured — {formatMoney(ads.featured)}</li>
            <li>Premium — {formatMoney(ads.premium)}</li>
            <li>Homepage banner — {formatMoney(ads.homepage_banner)}</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
